module.exports = __webpack_public_path__ + "static/img/card_09@2x.5f0abff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/card_09@2x.png
// module id = 72LN
// module chunks = 0